module.exports = __webpack_public_path__ + "static/media/app-04.e2bc41f7.png";